import { brandName, categories, navLinks } from '@/mocks/homeData';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto max-w-[1400px] px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-12 lg:gap-8">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500 text-xl text-background-50">
                <i className="ri-flashlight-fill" aria-hidden="true" />
              </span>
              <h2 className="font-heading text-xl font-bold text-background-50">{brandName}</h2>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200">
              聚合网络红人热点事件的首发、速递与进展梳理。我们只做多源核对与时间线还原,不下场站队,把判断留给你。
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-3 text-base">
              <a
                href="#contact"
                aria-label="订阅热点速递"
                className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md bg-background-50/10 text-background-100 transition-colors hover:bg-primary-500"
              >
                <i className="ri-mail-send-line" aria-hidden="true" />
              </a>
              <a
                href="#live"
                aria-label="查看实时速递"
                className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md bg-background-50/10 text-background-100 transition-colors hover:bg-primary-500"
              >
                <i className="ri-live-line" aria-hidden="true" />
              </a>
              <a
                href="#faq"
                aria-label="查看常见问题"
                className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md bg-background-50/10 text-background-100 transition-colors hover:bg-primary-500"
              >
                <i className="ri-question-line" aria-hidden="true" />
              </a>
            </div>
          </div>

          <nav aria-label="页脚导航" className="lg:col-span-3">
            <h3 className="font-heading text-sm font-bold tracking-wide text-accent-400">快速导航</h3>
            <ul className="mt-4 space-y-3 text-sm">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="cursor-pointer text-background-200 transition-colors hover:text-background-50"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div className="lg:col-span-2">
            <h3 className="font-heading text-sm font-bold tracking-wide text-accent-400">主题分类</h3>
            <ul className="mt-4 space-y-3 text-sm">
              {categories.slice(1, 6).map((cat) => (
                <li key={cat.id}>
                  <a
                    href="#latest"
                    className="cursor-pointer text-background-200 transition-colors hover:text-background-50"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h3 className="font-heading text-sm font-bold tracking-wide text-accent-400">联系我们</h3>
            <ul className="mt-4 space-y-3 text-sm text-background-200">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-accent-400" aria-hidden="true" />
                <span className="break-all">tips@heibao-live.example</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-file-text-line mt-0.5 text-accent-400" aria-hidden="true" />
                <span>线索投稿 7×24 小时接收</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-shield-check-line mt-0.5 text-accent-400" aria-hidden="true" />
                <span>隐私优先,不公开投稿人信息</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-50/15 pt-6 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {brandName}. 内容均为公开信息整理,涉及人物均为网络化名,仅供理性讨论。</p>
          <p className="flex flex-wrap items-center gap-4">
            <a href="#about" className="cursor-pointer transition-colors hover:text-background-50">
              内容原则
            </a>
            <span className="text-background-50/25">|</span>
            <a href="#faq" className="cursor-pointer transition-colors hover:text-background-50">
              免责声明
            </a>
            <span className="text-background-50/25">|</span>
            <a href="#contact" className="cursor-pointer transition-colors hover:text-background-50">
              联系编辑
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}